import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiUsersList, apiUsersView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/users/getData', async datas => {
    const { data } = await apiUsersList(datas)
    return data
})

export const getView = createAsyncThunk('admin/users/getView', async id => {
    if (!id) return viewData
    const { data } = await apiUsersView(id)
    data.image = ''
    return data
})

const viewData = {
    role_id: '',
    parent_id: '',
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    password_confirmation: '',
    designation: '',
    department: '',
    mobile_no: '',
    image: '',
    permissions: [],
}

export const usersSlice = createSlice({
    name: 'admin/users',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = usersSlice.actions

export default usersSlice.reducer
